module.exports = __webpack_public_path__ + "img/iq.30dee02.svg";